import { ReactNode } from 'react'
import { Style } from 'inlines'
import Row from '@app/components/layout/Row'
import Column from '@app/components/layout/Column'
import useMediaQuery from '@app/util/useMediaQuery'

type DiscoverPageLayoutProps = {
    children: ReactNode
    sidebar?: ReactNode
    style?: Style
}

export const DiscoverPageLayout = ({
    children,
    sidebar,
    style,
}: DiscoverPageLayoutProps) => {
    const isMobile = useMediaQuery()

    if (isMobile) {
        return (
            <Column alignItems="stretch" gap="1.5rem" style={style}>
                {children}
            </Column>
        )
    }

    return (
        <Row gap="1.5rem" alignItems="flex-start" style={style}>
            <Column alignItems="stretch" gap="1.5rem" style={{ flex: '1 1 0%' }}>
                {children}
            </Column>
            {sidebar && (
                <Column
                    alignItems="stretch"
                    style={{ flex: '0 0 23rem' }}
                >
                    {sidebar}
                </Column>
            )}
        </Row>
    )
}
